import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import InputPesel from '../form/inputs/InputPesel';
import InputDowod from '../form/inputs/InputDocument';
import InputCalendar from '../form/inputs/inputCalendar';
import Button from '../buttons/Button';
import Select from '../form/selects/Select';
import Radio from '../form/radio/Radio';
import maritalStatuses from './../../static-data/marital-status.json'
import documents from './../../static-data/documents.json'
import countries from './../../static-data/countries.json';
import citizenship from './../../static-data/citizenship.json';
import SelectColumnWritable from './../form/selects/SelectColumnWritable';
import "moment/locale/pl";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';
import Text from '../text/Text';

const materialTheme = createMuiTheme({
    overrides: {
        MuiPickersCalendarHeader: {
            switchHeader: {
                color: '#74726b',
            },
          },
      MuiPickersDay: {
            day: {
                color: '#74726b',
            },
        },
    }
  });

const AuthorizedPersons = ( props ) => {
    let [ load, setLoad ]                           = useState(false);   
    let [ isOpenFirst, setIsOpenFirst ]             = useState([]);   
    let [ isOpenSecond, setIsOpenSecond ]           = useState([]); 
    let [ forceValidateNip, setForceValidateNip ]   = useState(false);
    let [ forceValidate, setForceValidate ]         = useState(false);
    let [ updateArray, setUpdateArray ]             = useState(0);
    const dispatch        = useDispatch()
    let registryType           = useSelector(state => state.registryType)
    let authorizedPersons      = useSelector(state => state.authorizedPersons)
    let dataFromGUS          = useSelector(state => state.dataFromGUS)
    let productPrice                      = useSelector(state => state.productPrice)

    useEffect(() => {
      if( !load ) {
        if ( dataFromGUS.fiz_imie1 ) {
            updateValue(dataFromGUS.fiz_imie1, 0, 'name')
        }
        if ( dataFromGUS.fiz_imie1 ) {
            updateValue(dataFromGUS.fiz_nazwisko, 0, 'surname')
        }
        setLoad(true);
      }
    }, [load])

    // useEffect(() => {
    //     if( !load ) {
    //       if ( dataFromGUS.fiz_imie1 && authorizedPersons[0]?.name != dataFromGUS.fiz_imie1 ) {
    //           updateValue(dataFromGUS.fiz_imie1, 0, 'name')
    //       }
    //       setLoad(true);
    //     }
    //   }, [load, dataFromGUS, authorizedPersons])
    
    
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }
    
    let prev = () => {
        props.prev();
    }
    let next = async () => {
        await setForceValidate(true)
        await wait(100);
        let errors = await checkErrors();
        await wait(100);
        await setForceValidate(false)


        if ( !errors ) {
            props.next();
        };
    }

    //update local array
    let updateValue =  async( val, index, property ) => {
        let copyArray = authorizedPersons;
        copyArray[index][property] = val;
        dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }

    let addItemToArray = async() => {
        await setForceValidate(true);
        await wait(10);
        let errors = await checkErrors();
        if ( !errors ) {
            await setForceValidate(false);

            let el = {
                name: '',
                surname: '',
                pesel: '',
                document: '',
                countryBirth: '',
                citizenship: '',
                citizenship2Status: false,
                citizenship2: '',
                authorizationEcontract: false,
                authorizationEmail: '',
                authorizationPhone: '',
                id: '',
                idReleaseDate: null,
                idExpirationDate: null,
                address: '',
                maritalStatus: '',
            };
            let copy = [ ...authorizedPersons, el ];
            dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copy })

        } 
    }
    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll('.error-item');
        if( elements.length > 0 ) {
            result = true;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: elements[0].offsetTop - 185
            });
        } else {
            result = false;
        }
        return result;
        
    }

    let removeLastFromArray = async () => {
        let copyArray = authorizedPersons;
        await copyArray.splice(-1, 1);
        await dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }
    
    const updateCalendar = (type, index, status) => {
        let newRes = [];
        if(status) {
            if(type == "first") {
                if(!isOpenFirst.includes(index)) {
                    setIsOpenFirst([...isOpenFirst, index]);
                }
            }else if(type == "second") {
                if(!isOpenSecond.includes(index)) {
                    setIsOpenSecond([...isOpenSecond, index]);
                }
            }
        }else{
            if(type == "first") {
                if(isOpenFirst.includes(index)) {
                    newRes = isOpenFirst.filter(first => first == index ? null : first)
                    setIsOpenFirst(newRes);
                }
            }else if(type == "second") {
                if(isOpenSecond.includes(index)) {
                    newRes = isOpenSecond.filter(second => second == index ? null : second)
                    setIsOpenSecond(newRes);
                }
            }
        }
    }

    const checkExpirationDate = (date, index) => {
        let val = moment(date, "YYYY-MM-DD");
        val = val.add(10, 'years').format('YYYY-MM-DD');
        if ( authorizedPersons[index].document != "Inny (np. karta pobytu)" ) {
            updateValue(val, index, 'idExpirationDate');
        }
    }

    const checkReleaseDate = (date, index) => {
        let val = moment(date, "YYYY-MM-DD");
        val = val.subtract(10, 'years').format('YYYY-MM-DD');
        if ( authorizedPersons[index].document != "Inny (np. karta pobytu)" ) {
            if(authorizedPersons[index].document == "Dowód osobisty") {
                let dateNotUpdateRelease = moment("2021.08.02", "YYYY-MM-DD");
                let fromDate = moment(date, "YYYY-MM-DD");

                if(fromDate.isSameOrAfter(dateNotUpdateRelease)) {
                    // console.log('nie ma zakresu');
                }else{
                    updateValue(val, index, 'idReleaseDate');
                }
            }else{
                updateValue(val, index, 'idReleaseDate');
            }
        }
    }

    const getPlaceholderByDocument = document => {
        switch (document) {
            case 'Dowód osobisty':
                return  { 
                    serie: "Seria i numer dowodu osobistego",
                    dateStart: "Data wydania dowodu osobistego",
                    dateEnd: "Data ważności dowodu osobistego",
                };

            case 'Paszport':
                return  { 
                    serie: "Seria i numer paszportu",
                    dateStart: "Data wydania paszportu",
                    dateEnd: "Data ważności paszportu",
                };

            case 'Inny (np. karta pobytu)':
                return  { 
                    serie: "Seria i numer dokumentu",
                    dateStart: "Data wydania dokumentu",
                    dateEnd: "Data ważności dokumentu",
                };
            default:
                break;
        }
    }

    const getRegExpByDocument = document => {

        switch (document) {
            case 'Dowód osobisty':
                return /^.{5,15}$/;

            case 'Paszport':
                return  /^[A-z]{2}[0-9]{7}$/

            case 'Seria i numer dokumentu':
                return /^.{5,15}$/;
            default:
                break;
        }
        
    }

    const changeTypeReset = ( val, i ) => {
        if ( load && authorizedPersons.length > 0 ) {
            if ( val == authorizedPersons[i].document || authorizedPersons[i].document == '' ) {
                return false;
            } else {
                updateValue(null, i, 'idExpirationDate');
                updateValue(null, i, 'idReleaseDate');
                setUpdateArray(++updateArray)
            }
            
        }
    }

    return (
        <div className="customer-information authorized">
            <Heading title="osoby uprawnione do podpisania umowy" medium />
                 <div className="text">
                    { registryType == "CEIDG" && 
                        <p>Wskaż dane właściciela firmy lub w przypadku spółki cywilnej wszystkich właścicieli firmy.</p>
                    }
                    { registryType == "KRS" &&
                        <p>Wskaż dane członków Zarządu lub innych osób uprawnionych do reprezentowania firmy zgodnie z zapisem w KRS.</p>
                    }
                 </div>
                 { updateArray >= 0 && authorizedPersons && authorizedPersons.map( ( item, index ) => (
                     <>
                    {index > 0 &&
                        <div className="line big-margin" />
                    }
                     <div className="input-row">
                        <div className="col">
                            <Input  name={"name-"+index}
                                    id={"name-"+index}
                                    required={ true }
                                    setFunction={ val => { updateValue(val, index, 'name'); } }
                                    type="text"
                                    placehold={ "Imię" }
                                    val={ item.name }
                                    size="xxl" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 1 } 
                                    forceValidate={ forceValidate } />
                        </div>
                        <div className="col">
                            <Input  name={"surname-"+index}
                                    id={"surname-"+index}
                                    required={ true }
                                    setFunction={ val => { updateValue(val, index, 'surname'); } }
                                    type="text"
                                    placehold={ "Nazwisko" }
                                    val={ item.surname }
                                    size="xxl" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 0 } 
                                    forceValidate={ forceValidate } />
                        </div>
                        <div className="col">
                            <InputPesel  name={"pesel-"+index}
                                    id={"pesel-"+index}
                                    required={ true }
                                    setFunction={ val => { updateValue(val, index, 'pesel'); } }
                                    type="text"
                                    placehold={ "PESEL" }
                                    val={ item.pesel }
                                    size="xxl" 
                                    regExp={/^[0-9]{11}$/}
                                    allowChars={/^[0-9]{0,11}$/}
                                    minChar={ 1 } 
                                    forceValidate={ forceValidate } />
                        </div>
                    </div>

                    <div className="line" />

                    <div className="input-row">
                        <div className="col">
                            <Select
                                id="type-register"
                                required={ true }
                                data={ documents }  
                                forceValidate={ forceValidate } 
                                val={ item.document }
                                placehold="Dokument tożsamości" 
                                setFunction={ val => {  changeTypeReset( val, index ); updateValue(val, index, 'document'); } }
                            />
                        </div>
                        <div className="col col-dir">
                            <SelectColumnWritable
                                id={`citizenship-${index}`}
                                required={ true }
                                // data={ countries } 
                                data={ citizenship && citizenship.filter(c => c.name != item.citizenship2) } 
                                forceValidate={ forceValidate } 
                                val={ item.citizenship }
                                placehold="Obywatelstwo" 
                                setFunction={ (val) => updateValue(val, index, 'citizenship') } />
                                {!item.citizenship2Status &&
                                    <p className="more-citizenship" onClick={() => updateValue(!item.citizenship2Status, index, 'citizenship2Status') }>Dodaj kolejne obywatelstwo</p>
                                }
                        </div>
                        {item.citizenship2Status &&
                            <div className="col">
                                <SelectColumnWritable
                                    id={`citizenship2-${index}`}
                                    required={ false }
                                    data={ citizenship && citizenship.filter(c => c.name != item.citizenship) } 
                                    forceValidate={ forceValidate } 
                                    val={ item.citizenship2 }
                                    placehold="Obywatelstwo 2" 
                                    setFunction={ (val) => updateValue(val, index, 'citizenship2') } />
                            </div>
                        }
                        <div className="col">
                            <SelectColumnWritable
                                id={`country-birth-${index}`}
                                required={ true }
                                data={ countries } 
                                forceValidate={ forceValidate } 
                                val={ item.countryBirth }
                                placehold="Państwo urodzenia" 
                                setFunction={ (val) => updateValue(val, index, 'countryBirth') } />
                        </div>
                    </div>

                    { item.document &&
                        <div className="input-row">
                            <div className="col">
                                { item.document == 'Dowód osobisty' &&
                                    <InputDowod  name={"id-"+index}
                                                id={"id-"+index}
                                                required={ true }
                                                setFunction={ val => { updateValue(val, index, 'id'); } }
                                                type="text"
                                                placehold={ getPlaceholderByDocument( item.document ).serie }
                                                val={ item.id }
                                                size="xxl" 
                                                regExp={ getRegExpByDocument( item.document  ) }
                                                allowChars={/^.{0,15}$/}
                                                minChar={ 0 } 
                                                forceValidate={ forceValidate } />
                                }
                                { item.document != 'Dowód osobisty' &&
                                    <Input    name={"id-"+index}
                                                    id={"id-"+index}
                                                    required={ true }
                                                    setFunction={ val => { updateValue(val, index, 'id'); } }
                                                    type="text"
                                                    placehold={ getPlaceholderByDocument( item.document ).serie }
                                                    val={ item.id }
                                                    size="xxl" 
                                                    regExp={ getRegExpByDocument( item.document  ) }
                                                    allowChars={/^[A-Za-z][A-Za-z0-9]*$/}
                                                    minChar={ 0 } 
                                                    forceValidate={ forceValidate } />
                                
                                }
                                
                            </div>
                            <div className="col">
                                <InputCalendar  name={"idReleaseDate-"+index}
                                    id={"id-release-date-"+index}
                                    // required={ item.document == "Inny (np. karta pobytu)" ? false : true }
                                    required={ item.document == "Inny (np. karta pobytu)" ? true : true }
                                    setFunction={ val => { updateValue(val, index, 'idReleaseDate'); checkExpirationDate(val, index) } }
                                    // setFunction={ val => { updateValue(val, index, 'idReleaseDate'); } }
                                    // setOtherInput={ val => checkExpirationDate(val, index) }
                                    openCalendar={ () => updateCalendar("first", index, true) }
                                    type="text"
                                    placehold={  getPlaceholderByDocument( item.document ).dateStart }
                                    val={ item.idReleaseDate }
                                    size="xxl" 
                                    calendar={ true }
                                    regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                                    allowChars={/^[0-9-]{0,10}$/}
                                    minChar={  item.document == "Inny (np. karta pobytu)" ? 0 : 1 } 
                                    maxDate={new Date()}
                                    forceValidate={ forceValidate } />
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
                                        <KeyboardDatePicker
                                            cancelLabel="Anuluj"
                                            value={ item.idReleaseDate }
                                            placeholder="2018-10-10"
                                            onChange={date =>  { updateValue(moment(date).format("YYYY-MM-DD"), index, 'idReleaseDate'); checkExpirationDate(moment(date).format("YYYY-MM-DD"), index) } }
                                            maxDate={new Date()}
                                            format="YYYY-MM-DD"
                                            open={isOpenFirst.includes(index)}
                                            onOpen={() => updateCalendar("first", index, true)}
                                            onClose={() => updateCalendar("first", index, false)}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </div>
                            <div className="col">
                                <InputCalendar  name={"idExpirationDate-"+index}
                                    id={"id-expiration-date-"+index}
                                    // required={ item.document == "Inny (np. karta pobytu)" ? false : true }
                                    required={ item.document == "Inny (np. karta pobytu)" ? true : true }
                                    setFunction={ val => { updateValue(val, index, 'idExpirationDate'); checkReleaseDate(val, index) } }
                                    // setFunction={ val => { updateValue(val, index, 'idExpirationDate'); } }
                                    // setOtherInput={ val => checkReleaseDate(val, index) }
                                    openCalendar={ () => updateCalendar("second", index, true) }
                                    type="text"
                                    placehold={  getPlaceholderByDocument( item.document ).dateEnd }
                                    val={ item.idExpirationDate }
                                    size="xxl" 
                                    calendar={ true }
                                    regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                                    allowChars={/^[0-9-]{0,10}$/}
                                    minChar={  item.document == "Inny (np. karta pobytu)" ? 0 : 1 } 
                                    minDate={new Date()}
                                    forceValidate={ forceValidate } />
                                <ThemeProvider theme={materialTheme}>
                                    <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
                                        <KeyboardDatePicker
                                            cancelLabel="Anuluj"
                                            value={ item.idExpirationDate }
                                            placeholder="2018-10-10"
                                            onChange={date =>  { updateValue(moment(date).format("YYYY-MM-DD"), index, 'idExpirationDate'); checkReleaseDate(moment(date).format("YYYY-MM-DD"), index) } }
                                            minDate={new Date()}
                                            format="YYYY-MM-DD"
                                            open={isOpenSecond.includes(index)}
                                            onOpen={() => updateCalendar("second", index, true)}
                                            onClose={() => updateCalendar("second", index, false)}
                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </div>
                        </div>
                    }

                    { registryType == "CEIDG" && 
                        <div className="line" />
                    }
                    <div className="input-row">
                        { registryType == "CEIDG" && 
                        <>
                                <div className="col">
                                    <Input  name={"address-"+index }
                                            id={"address-"+index }
                                            required={ false }
                                            setFunction={ val => { updateValue(val, index, 'address'); } }
                                            type="text"
                                            placehold={ "Adres zamieszkania" }
                                            val={ item.address }
                                            size="xxl" 
                                            regExp={/.*/}
                                            allowChars={/.*/}
                                            minChar={ 0 } 
                                            forceValidate={ forceValidate } 
                                            tip={ true } 
                                            tipHeader="Adres zamieszkania"
                                            tipText="Podaj ulicę, numer domu, kod pocztowy oraz miasto." />
                                </div>
                                <div className="col">
                                    <Select
                                        id={"marital-statues-"+index }
                                        name={"marital-statues-"+index }
                                        data={ maritalStatuses }  
                                        required={ true }
                                        forceValidate={ forceValidate } 
                                        placehold="Stan cywilny" 
                                        val={ item.maritalStatus }
                                        setFunction={ val => { updateValue(val, index, 'maritalStatus'); } }  />
                                </div>
                            </>
                        }
                    </div>
                    {productPrice <= 50000 &&
                    <>
                        {/* nowe pola */}
                        <div className="line" />
                        <Heading title="E-podpis umowy" smallMargin />
                        <Heading small title="Czy wyrażasz zgodę na podpisanie umowy drogą elektroniczną (podpis kwalifikowany) za pośrednictwem wskazanej przez GRENKE platformy?" small />
                        <div className="input-row e-contract">
                            <div className="col">
                                {/* <Radio data={ [ "TAK", "NIE" ] }
                                    setFunction={ val => { updateValue(val, index, 'authorizationEcontract'); } }
                                    active={ item.authorizationEcontract } 
                                    gtmClass="initial-charge-radio" /> */}
                                    <div className="row">
                                        <CheckboxRadio  required={ true } 
                                                        setFunction={ val => { updateValue(val, index, 'authorizationEcontract'); } }
                                                        otherForceValidate={ forceValidate }
                                                        val={ item.authorizationEcontract }
                                                        text="TAK" />

                                        <CheckboxRadio  required={ true } 
                                                        setFunction={ val => { updateValue(val, index, 'authorizationEcontract'); } }
                                                        otherForceValidate={ forceValidate }
                                                        text="NIE" 
                                                        val={ item.authorizationEcontract } />
                                    </div>
                            </div>
                            {item.authorizationEcontract == "TAK" &&
                                <>
                                    <div className="col">
                                        <Input  id={"authorizationEmail-" + index }
                                                name={"authorizationEmail-" + index }
                                                required={ true }
                                                setFunction={ val => { updateValue(val, index, 'authorizationEmail'); } }
                                                type="text"
                                                placehold={ "Adres e-mail" }
                                                val={ item.authorizationEmail }
                                                size="xxl" 
                                                regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/}
                                                allowChars={/.*/}
                                                minChar={ 1 } 
                                                index={ index } 
                                                forceValidate={ forceValidate } />
                                    </div>
                                    <div className="col">
                                        <Input  id={"authorizationPhone-" + index }
                                                name={"authorizationPhone-" + index }
                                                required={ true }
                                                setFunction={ val => { updateValue(val, index, 'authorizationPhone'); } }
                                                type="text"
                                                placehold={ "Telefon kom." }
                                                val={ item.authorizationPhone }
                                                size="xxl" 
                                                regExp={/^[+0-9]{9,13}$/}
                                                allowChars={/^[+0-9]{0,13}$/}
                                                minChar={ 1 } 
                                                index={ index } 
                                                forceValidate={ forceValidate }/>
                                    </div>
                                </>
                            }
                        </div>
                        {/* end nowe pola */}
                    </>
                    }
                    </>
                 )) }

                <div className="input-row buttons-actions">
                    <div className="col">
                        <Button title="Dodaj osobę" class="blue reverse" 
                                add={ true } 
                                setFunction={ () => addItemToArray() } 
                                tip={ true } 
                                tipHeader="Dodaj osobę"
                                tipText="Dodaj osobę, jeżeli do reprezentowania firmy wymagane jest współdziałanie kilku osób. W przypadku 
                                spółek cywilnych dodaj wszystkich wspólników, niezależnie od zapisów w umowie spółki." />
                    </div>
                    <div className="col"></div>
                    { authorizedPersons.length > 1  &&
                        <div className="col">
                            <Button title="Usuń osobę" class="blue reverse" minus={ true } setFunction={ () => removeLastFromArray() } />
                        </div>
                    }
                    
                </div>

                <div className="line" />
                
                <div className="input-row nav-buttons">
                    <div className="col">
                        <Button title="Powrót" class="white reverse" arrowPrevBlue={ true } setFunction={ () => prev() } />
                    </div>
                    <div className="col"></div>
                    <div className="col">
                        <Button title="Dalej" class="blue" arrow={ true } setFunction={ () => next() } />
                    </div>
                </div>
        </div>
    )
}

export default AuthorizedPersons;